import { AuthContextProps } from "react-oidc-context";
import { getAppConfig } from "../../services/config";
import { getOrigin } from "./get-current-location";
import { EndSessionAction } from "../../lib/types";

/**
 * Initiates logout from the IdP
 */
export const logOutOfIdp = async (args: {
  auth: AuthContextProps;
  action?: EndSessionAction;
}) => {
  const config = getAppConfig();
  const siteOrigin = getOrigin();

  switch (args.action) {
    case EndSessionAction.ActionEndSession:
    case EndSessionAction.ActionCancelEndSession:
      // end-session confirmation
      const form = document.createElement("form");
      form.method = "POST";
      const endSessionEndpoint =
        args.auth.settings.metadata?.end_session_endpoint;
      form.action = endSessionEndpoint ?? `${config.idpUrl}/oidc/end_session`;

      const params = {
        client_id: config.openId.client_id,
        post_logout_redirect_uri: siteOrigin,
        ...(args.auth.user?.id_token
          ? { id_token_hint: args.auth.user.id_token }
          : {}),
        action: args.action!,
      };

      Object.entries(params).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);

      await args.auth.removeUser();
      form.submit();
      return;

    default:
      // end-session initiation
      args.auth.signoutRedirect({
        extraQueryParams: {
          client_id: config.openId.client_id,
        },
        post_logout_redirect_uri: siteOrigin,
      });
  }
};
